import { FormEvent, useContext, useState } from "react";
import Modal from "../../components/modal/Modal";
import FormWrapper from "../../components/forms/FormWrapper";
import useMultistepForm from "../../hooks/useMultistepForm";
import { useMutation, useQuery } from "@apollo/client";
import { FieldData } from "../../hooks/useForm";
import { GET_CHKLIST_ITEMS, SUBMIT_INSPECTION_FIXES, SUBMIT_INSPECTION_REVIEW_REQ } from "../../graphql/queries";
import FormInputField from "../../components/forms/inputs/FormInputField";
import { Checkbox, Text, Title } from "@mantine/core";
import UserContext from "../../context/UserContext";
import { getBaseUrl } from "../../graphql/api";

function RecordReviewForm({ onComplete, record }: { onComplete: Function; record: any }) {
   console.log({ record })
   const userCtx = useContext(UserContext);
   const canFixDefects = userCtx?.hasPermission("FixDefects");
   let initData = new Map<string, any>();
   const checklists = record.checklists.map((c: any) => {
      return { ...c }
   })
   console.log({ checklists })
   checklists.forEach((c: any) => {
      if (c.attachments.length) {
         initData = new Map<string, any>([
            ...initData,
            [`item-${c.itemId}`, c.optionValue],
            [`item-${c.itemId}-image`, c.attachments.map((a: any) => a.filename)],
            [`item-${c.itemId}-reason`, c.remarks],
         ]);
      } else {
         initData = new Map<string, any>([
            ...initData,
            [`item-${c.itemId}`, c.optionValue],
            [`item-${c.itemId}-reason`, c.remarks],
         ]);
      }
   });
   ["customer", "driver", "site", "transporter"].forEach((k: string) => {
      let val = record[k];
      if (val) initData.set(`${k}Id`, val.id);
   });
   ["vehicleReg", "vehicleType", "remarks", "licenseNo"].forEach((k: string) => {
      let val = record[k];
      if (val) initData.set(k, val);
   });

   console.log({ initData })
   let rInitData = new Map<string, any>();
   let fInitData = new Map<string, any>();
   const { data, loading, error } = useQuery(GET_CHKLIST_ITEMS);
   const [formData] = useState(initData);
   const [rFormData, setFormData] = useState(rInitData);
   const [fFormData, setFixFormData] = useState(fInitData);
   const [submitInspectionReviewReq] = useMutation(SUBMIT_INSPECTION_REVIEW_REQ);
   const [submitInspectionFixes] = useMutation(SUBMIT_INSPECTION_FIXES);
   function updateFormData({ name, value }: FieldData) {
      setFormData((prev) => {
         return new Map([...prev, [name, value]]);
      });
   }

   const items = data?.getAllItems?.map((i: any) => {
      return {
         ...i
      }
   }) || []

   const getField = (i: any) => {
      let fName = `item-${i.id}`
      let cItem = checklists.find((c: any) => c.itemId === i.id)
      console.log({ i, cItem })
      return {
         name: fName,
         label: i.name,
         cols: 2,
         type: "radio",
         onChange: updateFormData,
         formData: formData,
         options: {
            required: true,
         },
         readOnly: true,
         choices: [
            { label: "Compliant", value: "Compliant" },
            { label: "Partially Compliant", value: "Partial" },
            { label: "Flawed", value: "Flawed" },
         ],
         conditions: [
            {
               allow: (value: any) => ["Flawed", "Partial"].includes(value),
               present: (
                  <FormInputField
                     label='Reason'
                     name={`item-${i.id}-reason`}
                     formData={formData}
                     options={{
                        required: true,
                     }}
                     readOnly={true}
                  />
               ),
            },
            {
               allow: (value: any) => ["Flawed"].includes(value),
               present: (
                  <FormInputField
                     label='Provide image'
                     name={`item-${i.id}-image`}
                     type='file'
                     isMulti
                     onChange={updateFormData}
                     formData={formData}
                     options={{
                        required: true,
                     }}
                     readOnly={true}
                  />
               ),
            },
         ],
      };
   };


   const onSubmitFixes = (ev: FormEvent) => {
      ev.preventDefault();
      let fixes = [...fFormData].map(([key, value]) => {
         let val = key.split("-")[1]
         return parseInt(val)
      })
      submitInspectionFixes({
         variables: {
            data: {
               fixes: fixes,
               inspectionId: record.id,
            },
         },
      })
         .then((res) => {
            if (res.data) {
               onComplete();
            } else {
               console.error("Error: ", res.errors);
            }
         })
         .catch(console.error);
   }

   const onSubmit = (ev: FormEvent) => {
      ev.preventDefault();
      let data = Object.fromEntries(rFormData);
      submitInspectionReviewReq({
         variables: {
            data: {
               ...data,
               inspectionId: record.id,
            },
         },
      })
         .then((res) => {
            if (res.data) {
               onComplete();
            } else {
               console.error("Error: ", res.errors);
            }
         })
         .catch(console.error);

   };
   let steps: any[] = [];
   if (data && !loading) {
      let max = 5;
      let step: any;
      data.getAllItems.filter((i: any) => {
         let f = getField(i)
         let value = formData.get(f.name);
         return ["Partial", "Flawed"].includes(value);
      }).forEach((i: any, idx: number) => {
         if (idx === 0 || idx % max === 0) {
            if (step) {
               steps.push(step);
            }
            step = {};
         }
         step.fields = step.fields || [];
         step.fields.push(getField(i));
      });
      if (step) {
         steps.push(step);
      }
   }
   const { numberOfSteps, currentStepIndex, step, next, back, isFirstStep, isLastStep } = useMultistepForm(
      steps.map((s, idx_) => (
         <FormWrapper key={idx_} fields={s.fields} updateFormData={updateFormData} formData={formData} />
      ))
   );

   if (loading)
      return (
         <Modal
            header={
               <div className='title flex justify-between items-center w-full'>
                  <h2>Inspection Review</h2>
               </div>
            }
            handleClose={() => onComplete()}
            className='checklist-form'
         >
            <p>Loading setups...</p>
         </Modal>
      );
   if (error) {
      console.error(error);
      return <p>Error...</p>;
   }

   const ReviewForm = () => {
      console.log({ steps })
      return <div>
         <form onSubmit={onSubmitFixes} autoComplete='nope' className="my-2">
            {canFixDefects && <Title order={6} c="gray">Select fixed items and submit</Title>}
            {steps[0]?.fields.map((f: any, idx: number) => {
               console.log({ f, formData })
               let itemId = parseInt(f.name.split("-")[1])
               let value = formData.get(f.name);
               let reason = formData.get(`${f.name}-reason`);
               let image = formData.get(`${f.name}-image`);
               let cItem = checklists.find((c: any) => c.itemId === itemId)
               let readOnly = cItem.tFixedAt ? true : false
               console.log({ readOnly, itemId, cItem, value })
               // let imageUrl = image ? URL.createObjectURL(image) : null;
               // console.log({ value, reason, imageUrl });



               return (
                  <div key={idx} className='flex gap-2 items-start py-2'>
                     <Checkbox
                        name={f.name}
                        onChange={({ currentTarget: { checked } }) => {
                           setFixFormData((prev) => {
                              return new Map([...prev, [f.name, checked]]);
                           });
                        }
                        }
                        checked={fFormData.get(f.name)}
                        disabled={readOnly}
                     />
                     <div className="flex-1 bg-slate-100 flex flex-col gap-2">
                        <label className="bg-blue-100 p-1">{f.label}</label>
                        <div className="flex gap-2 justify-between items-center p-1">
                           <Text><b>Status:</b> {value}</Text>
                           {reason && <Text className='text-sm text-gray-500'><b>Reason:</b> {reason}</Text>}
                           {image && (<div className='flex gap-2 items-center'>
                              <img
                                 src={`${getBaseUrl()}/uploads/${image}`}
                                 className="max-w-[200px] aspect-video object-cover rounded-lg shadow border"
                              />
                           </div>)}
                        </div>
                        <div className="flex justify-end p-1">
                           {cItem.tFixedAt
                              ? <Text c="orange" size="xs">Already attended, pending re-inspection!</Text>
                              : <Text c="red" size="xs">Pending for fix!</Text>}
                        </div>
                     </div>
                  </div>
               );
            }
            )}
            {canFixDefects && <div className='form-controls flex gap-3 justify-end py-2 text-lg'>
               <button type='submit' className='border rounded px-5 py-1 bg-primary text-white btn-sm'>
                  Submit
               </button>
            </div>
            }
         </form>
      </div>

   }
   console.log({ step });
   return (
      <Modal
         header={
            <div className='title flex justify-between items-center w-full'>
               <h2>Inspection Review</h2>
            </div>
         }
         handleClose={() => onComplete()}
         className='checklist-form2 flex flex-col gap-2'
      >
         <ReviewForm />
      </Modal>
   );
}

export default RecordReviewForm;
